import React from 'react';
import PropTypes from 'prop-types';

const PRIORITY_BADGES = {
  high: 'bg-rose-100 text-rose-700',
  urgent: 'bg-rose-100 text-rose-700',
  medium: 'bg-amber-100 text-amber-700',
  normal: 'bg-amber-100 text-amber-700',
  low: 'bg-slate-100 text-slate-600',
};

const formatDate = (value) => {
  if (!value) return '—';
  try {
    return new Date(value).toLocaleDateString();
  } catch {
    return value;
  }
};

const TaskTable = ({ tasks = [] }) => {
  if (!tasks.length) {
    return (
      <div className="rounded-xl border border-indigo-100 bg-white px-4 py-3 text-sm text-slate-500">
        Aucune tâche à afficher.
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {tasks.map((task) => {
        const priorityClass =
          PRIORITY_BADGES[(task.priority || '').toLowerCase()] || 'bg-slate-100 text-slate-600';
        return (
          <div
            key={task.id}
            className="rounded-2xl border border-indigo-100/70 bg-white/90 p-4 shadow-sm"
          >
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div className="space-y-1">
                <p className="text-sm font-semibold text-slate-900">{task.name}</p>
                <p className="text-xs text-slate-500">
                  {task.objective_name || 'Objectif non précisé'}
                </p>
              </div>
              <span
                className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${
                  task.is_completed ? 'bg-emerald-100 text-emerald-700' : 'bg-indigo-100 text-indigo-700'
                }`}
              >
                {task.is_completed ? 'terminée' : 'en cours'}
              </span>
            </div>

            <div className="mt-4 grid gap-3 text-xs text-slate-600 sm:grid-cols-3">
              <div className="flex flex-col">
                <span className="text-[11px] uppercase tracking-wide text-slate-400">Owner</span>
                <span className="text-sm text-slate-800">{task.owner_name || 'Non assignée'}</span>
              </div>
              <div className="flex flex-col">
                <span className="text-[11px] uppercase tracking-wide text-slate-400">Échéance</span>
                <span className="text-sm text-slate-800">{formatDate(task.due_date)}</span>
              </div>
              <div className="flex flex-col">
                <span className="text-[11px] uppercase tracking-wide text-slate-400">Priorité</span>
                <span className={`inline-flex w-fit items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${priorityClass}`}>
                  {task.priority || 'Non définie'}
                </span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

TaskTable.propTypes = {
  tasks: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      name: PropTypes.string.isRequired,
      is_completed: PropTypes.bool,
      objective_name: PropTypes.string,
      owner_name: PropTypes.string,
      due_date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
      priority: PropTypes.string,
    })
  ),
};

export default TaskTable;
